export enum ImagePresentation {
  Circle = 'circle',
  Arch = 'arch',
}

export interface Product {
  code: number;
  title: string;
  href: string;
  partner: {
    name: string;
  };
  image: {
    normal: string;
    original: string;
  };
  preSalePrice: {
    gbp: number;
  } | null;
  price: {
    gbp: number;
  } | null;
}

export type StickerShape =
  | 'oval'
  | 'circle'
  | 'sock'
  | 'soap'
  | 'chocolate'
  | 'pot'
  | 'bauble'
  | 'bottle';

export type StickerColor = 'yellow' | 'purple' | 'green' | 'dark purple' | 'dark green';

export interface Sticker {
  shape: StickerShape;
  color: StickerColor;
  content: string;
}
